import { j as a } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as x } from "../../../node_modules/clsx/dist/clsx.m.js";
import { memo as v } from "react";
import j from "../../atoms/Button/Button.js";
import I from "./ButtonGroup.module.scss.js";
const b = ({
  list: r,
  selected: l,
  className: s,
  loading: u,
  onSelectChange: n,
  disabled: p,
  ...c
}) => /* @__PURE__ */ a.jsx(
  "div",
  {
    className: x(I.buttonGroupContainer, s),
    ...c,
    children: r == null ? void 0 : r.map((o, d) => {
      const f = o.value;
      return /* @__PURE__ */ a.jsx(
        j,
        {
          color: "neutral",
          variant: "ghost",
          size: "small",
          label: o == null ? void 0 : o.label,
          iconOnly: o == null ? void 0 : o.iconOnly,
          leadingIcon: o == null ? void 0 : o.leadingIcon,
          trailingIcon: o == null ? void 0 : o.trailingIcon,
          loading: u,
          disabled: p,
          onClick: () => n == null ? void 0 : n(o == null ? void 0 : o.value),
          pressed: f === l
        },
        d
      );
    })
  }
), k = v(b);
export {
  b as ButtonGroup,
  k as default
};
//# sourceMappingURL=ButtonGroup.js.map
